import { Core } from "@faire/design-tokens";
import { MARKETPLACE_LEFT_AND_RIGHT_MARGIN_MOBILE } from "@faire/retailer-visitor-shared/features/Marketplace/styleConsts";
import { Column, Row } from "@faire/web/slate/Layout";
import { getSpacing } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import styled, { css } from "styled-components";

export const PaddedContainer = styled(Column)<{ $noPaddingOnMobile?: boolean }>`
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;

  ${(props) =>
    props.$noPaddingOnMobile
      ? ""
      : css`
          padding: ${getSpacing(0, "2x")};
        `}
  ${responsiveMediaQueries.tabletAndAbove} {
    padding: ${getSpacing(0, "5x")};
  }

  ${responsiveMediaQueries.desktopAndAbove} {
    padding: ${getSpacing(0, "10x")};
  }
`;

export const PaginationRow = styled(Row).attrs({ align: "flex-start" })`
  margin: 0 -${MARKETPLACE_LEFT_AND_RIGHT_MARGIN_MOBILE}px;
  border-top: 1px solid ${Core.border.muted};
  padding: ${getSpacing("3x", 0)};

  ${responsiveMediaQueries.tabletAndAbove} {
    margin: ${getSpacing("2x", 0, 0)};
  }
`;
